import { render, staticRenderFns } from "./LiveJournal.vue?vue&type=template&id=364c4c55&scoped=true"
import script from "./LiveJournal.vue?vue&type=script&lang=js"
export * from "./LiveJournal.vue?vue&type=script&lang=js"
import style0 from "./LiveJournal.vue?vue&type=style&index=0&id=364c4c55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c4c55",
  null
  
)

export default component.exports